module.exports = __webpack_public_path__ + "static/assets/daa425189a3f3db03ea72d211cd9a50d.jpg";